// Module
var code = "<div class=\"bs-small-card bs-card\"> <div class=gs-small-card-title>{{title}} <span v-if=hasTooltip class=\"bs-tooltip tooltip-right bs-badge badge-info badge-information\" :data-tooltip=msg> </span> </div> <div class=gs-small-card-content>{{content}} </div> <div class=gs-small-card-action> <slot></slot> </div> </div> ";
// Exports
module.exports = code;